import TextInput from "../form/TextInput";
import { Grid } from "@mui/material";
import { edit } from '../../slices/modelsFilterSlice';
import "./ModelsFilter.css";

function ModelsFilter() {
    return (
        <div className="models-filter" style={{
            borderRadius: "17px",
            padding: "17px 24px",
            backgroundColor: "#f2f4f8",
            marginTop: "20px"
        }}>
            <Grid container spacing={1}>
                <Grid item md={12}>
                    <TextInput
                        stateName="modelsFilter"
                        label="Search"
                        valueName="name"
                        dispatchFunc={edit}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export default ModelsFilter;